<style>

input[type="password"]{
  background-color: inherit;
  border: 0;
  border-radius: 0;
  border-bottom: 2px white solid;
  color: white;
  background-color: rgba(255,255,255,0.2);
}

.bg{
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-image: url("/i/signup-bg-wizard.jpg");
  background-size: cover;
  color: black;
  padding: 20px;
  overflow-y: scroll;
}

.margin{
  margin-top: 50px;
}

</style>

<div class="bg">
  <div class="title-signup">Create a password</div>
  <div class="margin">
    <!-- <input type="password" bind:value="{password}"> -->
    <ValidPasswordInput bind:value="{password}" valid="{valid}" on:changed="{check}"></ValidPasswordInput>
  </div>
  <div class="margin small">10 or more characters required</div>
  
  <div class="has-buttons"></div>
  
</div>

<!-- <div class="next">
  <button on:click="{next}" disabled="{nextDisabled}">Next</button>
</div> -->
<NextButton on:click="{next}" disabled="{nextDisabled}"></NextButton>

<script>

import {push, pop, replace, location, link} from 'svelte-spa-router';

import forge from "node-forge";

import ValidPasswordInput from "../../../../components/ValidPasswordInput.svelte";
import NextButton from "../../../../components/NextButton.svelte";

import Signup from "../../../../helpers/Signup.js";
import Validate from "../../../../helpers/Validate.js";
import Normalize from "../../../../helpers/Normalize.js";

import { onMount } from "svelte";
onMount(async () => {
  try {
    Signup.verifyPersonalObject();
  } catch (e) {
    console.log("error:", e);
    
    if (e == "Must start from beginning") {
      document.location = "/";
    }
    
    return;
  }
  
  // if signup is already complete, then we push the user outta here...
  let signupComplete = Signup.getPersonalObject("signupComplete");
  if (signupComplete == true) {
    document.location = "/";
    return;
  }
  
  allowSignup = true;
  // Signup.saveToPersonalObject("password", "");
  passwordSaved = Signup.getPersonalObject("passwordSaved");
  password = Signup.getPersonalObject("password");
  tempPassword = Signup.getPersonalObject("tempPassword");
  
  if (passwordSaved == true) {
    valid = true;
    nextDisabled = false;
  } else {
    check();
  }
  
});

let allowSignup = false;
let tempPassword = "";
let password = "asdf123456";
let passwordSaved = false;
let valid = false;
let nextDisabled = true;
let signupDelayHandle = null;
let lastPassword = "";


function check(e) {
  clearTimeout(signupDelayHandle);
  
  if (password == lastPassword) return;
  
  passwordSaved = false;
  
  signupDelayHandle = setTimeout( async () => {
    lastPassword = password;
    try {
      Validate.allowSignup(allowSignup);
      Validate.password(password);
      valid = true;
      nextDisabled = false;
    } catch (e) {
      valid = false;
      nextDisabled = true;
      console.log("error:", e);
    }
  }, 450);
  
}


async function next() {
  
  if (passwordSaved == false) {
    if (password != tempPassword) {
      let keys = Signup.getPersonalObject("keys");
    
      let privateKey = forge.pki.decryptRsaPrivateKey(keys.pkey, tempPassword);
      let pemVersion = forge.pki.privateKeyToPem(privateKey);
      
      // console.log("pemVersion:", pemVersion);
      
      let privateKeyOut = forge.pki.encryptRsaPrivateKey(privateKey, password);

      // console.log("privateKeyOut", privateKeyOut);

      await Signup.saveToPersonalObject("tempPassword", password);
      await Signup.saveToPersonalObject("password", password);
      await Signup.saveToPersonalObject("passwordSaved", true);
      await Signup.saveToPersonalObject("keys", {cert: keys.cert, pkey: privateKeyOut});
      
      // console.log("saving user info");
      await Signup.savePasswordAndPrivateKey();
    }
  }
  
  push("/signup/profile/personal/gender");
}


</script>